import { TableCellColorfulText } from 'src/components/table-cell-colorful-text';

export default TableCellColorfulText;
